// Keep requests sequential: a driver may have several assigned orders, but only
// one can be active. The existing activation endpoint remains the authority.
export async function activateAssignedOrders(orders, activate, onProgress = () => {}) {
  const assigned = orders.filter((order) => order.status === "ASSIGNED");
  const results = [];
  for (const order of assigned) {
    try {
      await activate(order);
      results.push({ order, activated: true });
    } catch (error) {
      results.push({ order, activated: false, error });
    }
    onProgress(results.length, assigned.length);
  }
  return results;
}
